import { render, staticRenderFns } from "./RecordDialog2.vue?vue&type=template&id=98760c44&scoped=true"
import script from "./RecordDialog2.vue?vue&type=script&lang=js"
export * from "./RecordDialog2.vue?vue&type=script&lang=js"
import style0 from "./RecordDialog2.vue?vue&type=style&index=0&id=98760c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98760c44",
  null
  
)

export default component.exports